<template>
  <section id="confirmation" class="bd-index-fullscreen has-page-background hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6 has-text-centered">
            <form @submit.prevent="validateBeforeSubmit">
              <div v-if="confirmationType === 1">
                <!--<img src="@/assets/logo.png" alt="Image" width="20%">-->
                <i class="ri-checkbox-circle-line has-text-success is-size-2"></i>
                <h3>{{ $t('postconfirmation.success') }}</h3>
                <p class="has-text-grey-light">
                  {{ $t('postconfirmation.success-message') }}
                </p>
                <hr class="is-dark" />
                <p class="has-margin-bottom-20 is-size-5">{{ $t('postconfirmation.donation-sell') }}</p>
                <!--
                <div class="columns">
                  <div class="column">
                    <a @click.prevent="setType('Individual')" class="button is-mega is-primary is-outlined is-fullwidth">  
                      <i class="fas fa-user has-text-warning is-size-4"></i>
                      <br />
                      <div>{{ $t('postconfirmation.button-donate') }}</div>
                    </a>
                  </div>
                  <div class="column">
                    <a @click.prevent="setType('Business')" class="button is-mega is-primary is-outlined is-fullwidth">
                      <i class="fas fa-building has-text-warning is-size-4"></i>
                      <br />
                      <div>
                        {{ $t('newuser.button-business') }}
                      </div>
                    </a>
                  </div>
                </div>
                -->
                <hr />
                <div class="box has-background-grey-lighter has-box-shadow">
                  <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                    <input type="hidden" name="cmd" value="_s-xclick" />
                    <input type="hidden" name="hosted_button_id" value="KK9G3UH8TCU9U" />
                    <input type="image" src="https://www.paypalobjects.com/en_US/GB/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                    <img alt="" border="0" src="https://www.paypal.com/en_GB/i/scr/pixel.gif" width="1" height="1" />
                  </form>
                </div>
                <p>{{ $t('postconfirmation.donation-security') }}</p>
                <hr />
                <div class="columns">
                  <div class="column">
                    <router-link to="/activity" class="button is-primary is-outlined is-fullwidth">My Activity</router-link>
                  </div>
                  <div class="column">
                    <router-link to="/post" class="button is-primary is-outlined is-fullwidth">Post Again</router-link>
                  </div>
                  <div class="column">
                    <router-link to="/posts" class="button is-primary is-outlined is-fullwidth">Home</router-link>
                  </div>
                </div>


                <!--
                <b-field>
                  <b-radio-button v-model="userProfile.type"
                    native-value="Individual"
                    type="is-primary">
                    <b-icon icon="account"></b-icon>
                    <span>Individual</span>
                  </b-radio-button>
                  <b-radio-button v-model="userProfile.type"
                    native-value="Business"
                    type="is-success">
                    <b-icon icon="business"></b-icon>
                    <span>Business/Organisation</span>
                  </b-radio-button>
                </b-field>-->

                <!--
                <hr class="is-dark" />
                <p class="has-text-grey-light">
                  Accounts are seperated from business an individual user, this keeps the objective clean
                  makes it easier to hand over an account if a invidiual moves on form a business.
                </p>
                <img src="@/assets/logo.png" alt="Osla Social" width="20%">
                -->
              </div>
            
              <div v-if="confirmationType === 2">
                <div class="has-text-left">
                  <a @click.prevent="prev()">
                    <i class="ri-arrow-left-line has-text-info"></i>
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      confirmationType: 1,
    };
  },

  computed: {
    ...mapState(["userProfile"]),
  },
  methods: {
    logout() {
      fb.auth
        .signOut()
        .then(() => {
          this.$store.dispatch("clearData");
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    },

    prev() {
      this.confirmationType--;
    },
    snackbarSuccess() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("newuser.snackbar-success"),
        type: 'is-primary',
        position: 'is-bottom',
        actionText: null,
        class: 'has-background-info',
        queue: false,
        /*
        onAction: () => {
          this.$router.push("/posts");
        }*/
      })
    },
    snackbarError() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("newuser.snackbar-error"),
        type: 'is-info',
        position: 'is-bottom',
        actionText: 'Ok',
        queue: false,
        onAction: () => {
          this.$router.push("/newuser");
        }
      })
    },
    
  },
};
</script>